import api from './api';

const BASE = '/ajustes';

export const ajustesService = {
    listarNotificaciones: async () => {
        const response = await api.get(`${BASE}/notificaciones`);
        return response.data;
    },

    actualizarNotificacion: async (modulo, { destinatarios, frecuencia, activo }) => {
        const response = await api.put(`${BASE}/notificaciones/${modulo}`, {
            destinatarios,
            frecuencia,
            activo,
        });
        return response.data;
    },
};
